<template style="display: inline-block">
    <span v-if="typeof data === 'string'">
        <span v-html="markdownToHtml(data)" v-highlight></span>
    </span>
</template>

<script>
    import {markdownToHtml} from '@/utils/vue.tool';
    export default {
        name: "SimpleCode",
        props: ['data'],
        components: {},
        methods: {
            markdownToHtml
        }
    }
</script>

<style>
    /*ul, ol{*/
    /*    padding: 0;*/
    /*}*/
    /* 添加列表样式 */
    /*ul, ul>li{*/
    /*    list-style-type: circle; !* 实心圆点 *!*/
    /*}*/

    /*ol, ol>li{*/
    /*    list-style-type: disc; !* 实心 *!*/
    /*}*/
</style>